import { getHsOwnerIdInLocalStorage } from '../../../services/localStorage/localStorage';

export const ACQUISITION_IMPERSONATION_NOTICE =
  'Acquisizione non disponibile mentre stai visualizzando le lead di un altro utente. Esci dall’impersonificazione per acquisire una lead a tuo nome.';

/**
 * Acquisition writes a new lead in the name of the real operator, so it is the
 * one admin capability impersonation must not reach: while an impersonated
 * owner is selected the page shows the reason and offers no way to submit.
 *
 * The selected owner is the whole signal — the workspace is already admin-only,
 * and an admin is always *eligible* to impersonate, so eligibility says nothing
 * here. The backend remains authoritative: it withholds the acquisition scope
 * from an impersonated token, and this only keeps the operator from compiling a
 * command that could never be accepted.
 */
export const isAcquisitionBlockedByImpersonation = (): boolean =>
  Boolean(getHsOwnerIdInLocalStorage());
